import { WeblabItem } from 'src/redux/slices/weblab';
import WeblabId from 'src/weblab/weblabId';
import WeblabTreatment from 'src/weblab/weblabTreatment';

export default function checkWeblab(weblabId: WeblabId, weblabList: WeblabItem[]): boolean {
  return weblabList.findIndex(
    (weblab) => weblab.id === weblabId
    && weblab.treatment === WeblabTreatment.T1,
  ) >= 0;
}
